// One list of suggestions from the three readers: the name wins a conflict
// within a group, nothing repeats, and the list is capped so an upload
// manifest stays small.

import { LIBRARY_TAG_SUGGESTIONS_MAX } from "@shared/library-tags.js";
import { parseTag } from "@shared/library-tags.js";
import type { NewTag } from "@shared/api-types.js";

/** Groups where one value excludes another (a clip is one drum, in one key). */
const EXCLUSIVE = new Set(["drums", "key", "tempo"]);

export function mergeSuggestions(...lists: ReadonlyArray<readonly NewTag[]>): NewTag[] {
  const out: NewTag[] = [];
  const seen = new Set<string>();
  const takenGroup = new Set<string>();
  for (const list of lists) {
    for (const t of list) {
      if (seen.has(t.tag)) continue;
      const { group } = parseTag(t.tag);
      if (group && EXCLUSIVE.has(group)) {
        if (takenGroup.has(group)) continue;
        takenGroup.add(group);
      }
      seen.add(t.tag);
      out.push(t);
      if (out.length >= LIBRARY_TAG_SUGGESTIONS_MAX) return out;
    }
  }
  return out;
}
